import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Container, Grid, Typography, Card, CardContent } from "@material-ui/core";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const useStyles = makeStyles((theme) => ({
  relatedServices: {
    padding: "60px 0",
    backgroundColor: "#fff",
  },
  title: {
    fontWeight: "700",
    color: "#000000",
    fontSize: "32px",
    marginBottom: "40px",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
    },
  },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
    },
  },
  cardContent: {
    flexGrow: 1,
  },
  serviceName: {
    fontWeight: "600",
    color: "#07516c",
    fontSize: "20px",
    marginBottom: "10px",
  },
  serviceDescription: {
    color: "#2D2D2D",
    fontSize: "14px",
    lineHeight: "1.6",
    marginBottom: "15px",
  },
  learnMore: {
    display: "flex",
    alignItems: "center",
    color: "#07516c",
    fontWeight: "600",
    fontSize: "14px",
    "& svg": {
      marginLeft: "5px",
      fontSize: "18px",
    },
  },
}));

const RelatedServices = ({ services }) => {
  const classes = useStyles();
  
  if (!services || services.length === 0) {
    return null;
  }
  
  return (
    <div className={classes.relatedServices}>
      <Container maxWidth="lg">
        <Typography variant="h2" className={classes.title}>
          Related Services
        </Typography>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Link to={service.path} style={{ textDecoration: "none" }}>
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <Typography className={classes.serviceName}>
                      {service.name}
                    </Typography>
                    <Typography className={classes.serviceDescription}>
                      {service.description}
                    </Typography>
                    <div className={classes.learnMore}>
                      Learn More
                      <ArrowForwardIcon />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default RelatedServices;

